// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lDt5","col":"styles_col__3Olsu"};